import { newUUID, throwTranslatableError } from '@/core';
import { getDriversRequest, saveNewDriverRequest, deleteDriverRequest, updateDriverRequest } from '../requests';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

async function getDrivers({ state, commit }) {
	try {
		commit('set', () => { state.loading = true; });
		await fetchDrivers(state);
	} catch (err) {
		console.log(`Get drivers failed: ${  err}`);
	}
	
	commit('set', () => { state.loading = false; });

	async function fetchDrivers(state) {
		let response = await getDriversRequest();
		commit('set', () => { state.drivers = response; });
	}
}

async function deleteDrivers({ state, commit }, drivers) {
	let storedDrivers = state.drivers;
	let idsToRemove = [];
	for (let driver of drivers) {
		idsToRemove.push(driver.id);
	}
	try {
		for (let id of idsToRemove) {
			await deleteDriverRequest(id);
		}
		let updatedDrivers = storedDrivers.filter(x => idsToRemove.indexOf(x.id) < 0);
		commit('set', () => { state.drivers = updatedDrivers; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function updateDriver({ commit }, { driver, prop, data }) {
	if (driver[prop] === data) return;

	let driverClone = deepCopy(driver);
	commit('set', () => { driver[prop] = data; });
	let patch = rdbClient.createPatch(driverClone, driver);
	try {
		await updateDriverRequest(driver.id, { patch });
	} catch (err) {
		commit('set', () => { driver[prop] = driverClone[prop]; });
		throw (err);
	}
}

async function createDriver({ state, commit }, { name, phoneNumber, email }) {
	try {
		let driver = { id: newUUID(), name, phoneNumber, email };
		let driverDto = await saveNewDriverRequest(driver);

		let { drivers } = state;
		drivers.unshift(driverDto);
		commit('set', () => { state.drivers = drivers; });
		return driverDto;
	} catch (e) {
		throwTranslatableError(e, 'failedToAdd');
		return undefined;
	}
}

export default { getDrivers, createDriver, deleteDrivers, updateDriver };
